import * as cnt from '../../__storeFiles__/constants';

export const addDraftToQueue = (draftId, message) => ({
  type: cnt.ADD_DRAFT_TO_QUEUE,
  payload: { draftId, message },
});

export const removeDraftFromQueue = (draftId, refreshSection) => ({
  type: cnt.REMOVE_DRAFT_FROM_QUEUE,
  payload: { draftId, refreshSection },
});

export const sendUpdatesFromQueue = (templateIds, subject) => ({
  type: cnt.SEND_UPDATES_FROM_QUEUE,
  payload: { templateIds, subject },
});

export const clearState = () => ({ type: cnt.CLEAR_QUEUE_STATE });



// WEBPACK FOOTER //
// ./src/app/components/contracting/supplier-updates-queue/__storeFiles__/actions.js